export class RequestUtils {


    /**
     * Utility: Get a header value from any supported headers type.
     */
    static getHeader(headers: HeadersInit | undefined, key: string): string | undefined {
        if (!headers) return undefined;
        if (headers instanceof Headers) {
            return headers.get(key) ?? undefined;
        } else if (Array.isArray(headers)) {
            const found = headers.find(([k]) => k.toLowerCase() === key.toLowerCase());
            return found ? found[1] : undefined;
        } else if (typeof headers === 'object') {
            return headers[key] ?? headers[key.toLowerCase()];
        }
        return undefined;
    }

    /**
     * Utility: Set a header value for any supported headers type.
     */
    static setHeader(headers: HeadersInit | undefined, key: string, value: string): HeadersInit {
        if (!headers) return { [key]: value };
        if (headers instanceof Headers) {
            headers.set(key, value);
            return headers;
        } else if (Array.isArray(headers)) {
            const idx = headers.findIndex(([k]) => k.toLowerCase() === key.toLowerCase());
            if (idx >= 0) {
                headers[idx][1] = value;
            } else {
                headers.push([key, value]);
            }
            return headers;
        } else if (typeof headers === 'object') {
            headers[key] = value;
            return headers;
        }
        return headers;
    }

    /**
     * Utility: Delete a header from any supported headers type.
     */
    static deleteHeader(headers: HeadersInit | undefined, key: string): HeadersInit | undefined {
        if (!headers) return headers;
        if (headers instanceof Headers) {
            headers.delete(key);
            return headers;
        } else if (Array.isArray(headers)) {
            const idx = headers.findIndex(([k]) => k.toLowerCase() === key.toLowerCase());
            if (idx >= 0) headers.splice(idx, 1);
            return headers;
        } else if (typeof headers === 'object') {
            delete headers[key];
            delete headers[key.toLowerCase()];
            return headers;
        }
        return headers;
    }

    /**
     * Utility: Check if a header exists and matches a value (case-insensitive key).
     */
    static hasHeader(headers: HeadersInit | undefined, key: string, value?: string): boolean {
        const v = RequestUtils.getHeader(headers, key);
        if (value === undefined) return v !== undefined;
        return v === value;
    }

}
